<template>
  <div id="app-component">
    <router-view></router-view>
  </div>
</template>

<script>
import "../scss/default.scss";
export default {
  name: "app-components",
};
</script>

<style lang="scss" scoped>
#app-component {
  ::v-deep {
    @import "~bootstrap/dist/css/bootstrap";
    @import "~bootstrap-vue/dist/bootstrap-vue";
  }
}
</style>
